import './ProfileFollowing.styles.scss';
import { Avatar, Link } from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';
import React, { useContext, useEffect, useState } from 'react';
import { BulletList } from 'react-content-loader';
import MyThemeContext from '../../../contexts/theme-context/ThemeProviderContext';
import pickBkgClass from '../../../utils/pickBkgClass';
import pickSkeletonColor from '../../../utils/pickSkeletonColor';
import Axios from 'axios';
const ProfileFollowing = ({ fetchedUser }) => {
	const { themeName, themeType } = useContext(MyThemeContext);
	const [fetchingFollowing, setFetchingFollowing] = useState(true);
	const [fetchedFollowing, setFetchedFollowing] = useState([]);

	const sleep = ms => new Promise(r => setTimeout(r, ms));
	// following effect
	useEffect(() => {
		const cancelTokenSource = Axios.CancelToken.source();
		if (fetchedUser.profileUsername) {
			const fetchUserFollowing = async () => {
				setFetchingFollowing(true);
				await sleep(400);
				setFetchedFollowing([]);

				try {
					const response = await Axios.get(
						`/profile/${fetchedUser.profileUsername}/following`,
						{
							cancelToken: cancelTokenSource.token
						}
					);
					console.log('Fetched user Following', response);
					setFetchingFollowing(false);
					setFetchedFollowing(response.data);
				} catch (e) {
					if (Axios.isCancel(e)) {
						console.log('Cought cancel');
					} else {
						throw e;
					}
				}
			};
			fetchUserFollowing();
		}
		// cleanup
		return () => {
			cancelTokenSource.cancel();
		};
	}, [fetchedUser.profileUsername]);

	const renderFollowing = () => {
		if (fetchedFollowing.length > 0 && !fetchingFollowing) {
			return (
				<div
					className={`profileFollowing profilePanel  ${pickBkgClass(
						themeName,
						'soft'
					)}`}
				>
					{fetchedFollowing.map(({ avatar, username }, index) => (
						<div className={`avatar_link ${themeType}`} key={index}>
							<Avatar
								component={RouterLink}
								to={`/profile/${username}`}
								src={avatar ? avatar : null}
							/>
							<Link
								className="username"
								color="primary"
								component={RouterLink}
								to={`/profile/${username}`}
							>
								{username}
							</Link>
						</div>
					))}
				</div>
			);
		} else if (fetchedFollowing.length === 0 && fetchingFollowing) {
			return <BulletList width="50vw" {...pickSkeletonColor(themeName)} />;
		} else if (fetchedFollowing.length === 0 && !fetchingFollowing) {
			return (
				<div
					className={`profileFollowing profilePanel  ${pickBkgClass(
						themeName,
						'soft'
					)}`}
				>
					No Following
				</div>
			);
		}
	};

	return renderFollowing();
};

export default ProfileFollowing;
